import { render, staticRenderFns } from "./order_display.vue?vue&type=template&id=40ac5f51&scoped=true&"
import script from "./order_display.vue?vue&type=script&lang=js&"
export * from "./order_display.vue?vue&type=script&lang=js&"
import style0 from "./order_display.vue?vue&type=style&index=0&id=40ac5f51&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ac5f51",
  null
  
)

export default component.exports